// Color palette for prompt sliders - 8 distinct hues that cycle
export const PROMPT_COLORS = [
  { name: "gold", hsl: "45 90% 65%", hex: "#f0c040" },
  { name: "steel-blue", hsl: "210 60% 60%", hex: "#5a8fbf" },
  { name: "magenta", hsl: "330 80% 65%", hex: "#e84a9c" },
  { name: "purple", hsl: "270 70% 65%", hex: "#9b6dd7" },
  { name: "teal", hsl: "175 70% 45%", hex: "#22b8a0" },
  { name: "orange", hsl: "25 90% 60%", hex: "#e87830" },
  { name: "lime", hsl: "85 65% 55%", hex: "#8bc34a" },
  { name: "cyan", hsl: "195 85% 55%", hex: "#33b5d6" },
] as const;

export function getPromptColor(index: number) {
  return PROMPT_COLORS[index % PROMPT_COLORS.length];
}
